import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import Slides from '@ifeng-fe/ui_pc_slides';

const BigSlides = ({ content }) => {
    const sliderTmpl = item => {
        return (
                <div className="swiper-slide" >
                    <div className={styles.swiperItem}>
                        <a href={item.url} target="_blank">
                            <img src={formatImage(item?.thumbnail, 640, 360)} alt={item?.title} />
                            <div className={styles.swiperItemText} >{item?.title}</div>
                        </a>
                    </div>
                </div>
        );
    };

    const config = {
        dots: true,
        dotsAction: 'hover',
        autoplayInterval: 3000,
        dotStyle: styles.dot,
        dotCurrentStyle: styles.current,
        sliderTmpl,
    };

    return (
        <div className={`${styles.slides}`}>
            <Slides content={content} config={config} />
        </div>
    );
};

BigSlides.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(BigSlides);
